<template>
  <div class="watch-history-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input placeholder="请输入影片标题" size="small" class="param-input" v-model="params.id"></el-input>
       <el-select  size="small" clearable v-model="params.enable">
          <el-option v-for="item in channelsList" :value="item.value" :label="item.label" :key="item.value" ></el-option>
      </el-select>
       <el-select size="small" clearable v-model="params.enable">
          <el-option v-for="item in conditionList" :value="item.value" :label="item.label" :key="item.value" ></el-option>
      </el-select>
      <el-date-picker v-model="time" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="small" ></el-date-picker>
      <el-button type="primary" size="small">搜索</el-button>
    </div>
    <!-- 表格数据 -->
    <el-table :data="tableDate"  style="width: 100%" border  v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <el-table-column prop="" label="影片标题" align="center" fixed></el-table-column>
      <el-table-column prop="" label="演员" align="center"></el-table-column>
      <el-table-column prop="" label="影片频道" align="center"></el-table-column>
      <el-table-column prop="" label="观影条件" align="center"></el-table-column>
      <el-table-column prop="" label="最后一次观看时间" align="center" sortable>
        <template slot-scope="scope">
          {{scope.row.startTime | changeDate}}
        </template>
      </el-table-column>
      <el-table-column prop="" label="观看总数" align="center" sortable></el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 25]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
  </div>
</template>
<script>
import API from '@/api'
export default {
  data() {
    return {
      loading: false,
      tableDate: [1],
      total: 0,
      time: '',
      // 频道选项
      channelsList:[
        {
          label: '全部',
          value: 1
        },
        {
          label: '日本',
          value: 2
        },
        {
          label: '欧美',
          value: 3
        },
        {
          label: '动漫',
          value: 4
        },
        {
          label: '金币专区',
          value: 5
        },
        {
          label: '麻豆传媒',
          value: 6
        },
      ],
      // 观影条件选项
      conditionList:[
        {
          label: 'VIP',
          value: 1,
        },
        {
          label: '免费',
          value: 2,
        },
        {
          label: '限免',
          value: 3,
        },
        {
          label: '付费',
          value: 4,
        },
        {
          label: '全部',
          value: 5,
        }
      ],
      params: {
        id: '',
        pageNumber: 1,
        pageSize: 10,
        enable: ''
      }
    }
  },
  created() {
    // this.getRankList()
  },
  methods: {
    // 请求排行列表数据
    getRankList() {
      this.loading = true
      API.getRankList(this.params).then(res => {
        if (res.code === 200 && res.data) {
          this.tableData = res.data
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 编辑弹窗
    addAction(type,data){
      this.$refs.filmPopups.open(type,data)
    },
     // 监听编辑成功过后重新拉去数据
    handlerRankList() {
      this.param.pageNumber = 1
      this.param.pageSize = 10
      this.getRankList()
    },
    // 编辑排行弹窗
     editToday(type,row) {
      this.$refs.editToday.open(type,row)
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size
      this.getRankList()
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.params.pageNumber = number
      this.getRankList()
    },
  }
}
</script>
